import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';

import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PushNotifications } from '@pwaPortal/core/models/PushNotifications';
import { OneSignalNotificationsService } from '@pwaPortal/core/services/push-notifications/one-signal-notifications.service';
import { IPwaConfig } from '@sharedLib/models/interfaces/IPwaConfig';
import { NEW_PWA_CONFIG, PWA_CONFIG } from '@sharedLib/tokens/tokens';
import { NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN } from 'ngx-google-analytics';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

export function createAppConfig(config: IPwaConfig, newConfig: IPwaPreviewConfig): ApplicationConfig {
  return {
    providers: [
      provideHttpClient(withInterceptorsFromDi()),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes),
      { provide: PWA_CONFIG, useValue: config },
      { provide: NEW_PWA_CONFIG, useValue: newConfig },
      {
        provide: PushNotifications,
        useExisting: OneSignalNotificationsService,
      },
      provideServiceWorker('ngsw-worker.js', {
        // enabled: !isDevMode(),
        enabled: true,
        registrationStrategy: 'registerWhenStable:30000',
      }),
      importProvidersFrom(
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
          },
        })
      ),
      {
        provide: YOUTUBE_PLAYER_CONFIG,
        useValue: {
          loadApi: true,
          disablePlaceholder: true,
        },
      },
      {
        provide: NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
        useFactory: () => ({
          trackingCode: environment.app_config?.google_id,
        }),
      },
    ],
  };
}
